var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo2Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 131,
    viewBox: "0 0 151 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.342 78.6592L138.691 77.8523C142.362 70.5723 144.446 62.315 144.446 53.5557C144.446 24.3461 121.407 0.65918 92.9969 0.65918C68.3363 0.65918 47.7392 18.5006 42.7251 42.313C44.6261 42.044 46.5533 41.9006 48.524 41.9006C72.1208 41.9006 91.2529 61.5709 91.2529 85.8316C91.2529 93.1116 89.5176 99.9702 86.4743 106.013C88.6107 106.291 90.7907 106.452 92.9969 106.452C106.731 106.452 119.201 100.912 128.427 91.8923L149.678 96.5902L138.342 78.6592Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.524 41.9004C24.9272 41.9004 5.79515 61.5707 5.79515 85.8314C5.79515 95.1556 8.62921 103.798 13.4515 110.908L1.43506 125.28L25.058 122.536C31.79 127.1 39.8562 129.762 48.524 129.762C72.1209 129.762 91.2529 110.092 91.2529 85.8314C91.2529 61.5707 72.1209 41.9004 48.524 41.9004Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.24,
    height: 130,
    fill: "white",
    transform: "translate(0.379883 0.210938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo2Bw);
export default __webpack_public_path__ + "static/media/illustration-logo-2-bw.cac40e1c80ada62c283233d0cb660d42.svg";
export { ForwardRef as ReactComponent };